import styled from 'styled-components';

import {
  BodyMedium,
  H5,
} from '@/core/components/Typography';
import { HeaderWrapper } from '@/core/components/HeaderWrapper';
import { HoverImageWrapper } from '@/core/components/HoverImageWrapper';

import { breakpoint } from '@/themes/breakpoints';

export const Wrapper = styled(HeaderWrapper)`
  display: flex;
  min-height: 640px;
`;

export const ImageWrapper = styled(HoverImageWrapper)`
  display: none;

  @media ${breakpoint.md} {
    display: flex;
    width: 50%;
  }
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 40px;
  background-color: ${({ theme: { colors } }) => colors.decorativeBlue[100]};
  gap: 16px;

  @media ${breakpoint.md} {
    width: 50%;
    padding: 80px;
    gap: 24px;
  }
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 640px;
  object-fit: cover;

  @media ${breakpoint.sm} and (hover: hover) {
    transition: filter 0.5s ease;

    &:hover {
      filter: none;
    }
  }
`;

export const Header = styled.h5`
  ${H5}
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const SubHeader = styled.p`
  ${BodyMedium}
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral[700]};
`;

export const AuthorSection = styled.div`
  display: flex;
  flex: 1 0;
  justify-content: flex-start;
  align-items: flex-end;
`;

export const AuthorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Avatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.neutral[100]};
`;

export const AvatarImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
`;

export const Author = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AuthorName = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  font-size: 12px;
  line-height: 133.333%;
  letter-spacing: 0.3px;

  @media ${breakpoint.md} {
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.semiMedium};
    font-size: 16px;
    line-height: 150%;
  }
`;

export const AuthorHelpertext = styled.span`
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  font-size: 12px;
  line-height: 133.333%;
  letter-spacing: 0.3px;

  @media ${breakpoint.md} {
    font-size: 14px;
    line-height: 171.429%;
  }
`;

export const TopicsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
